window.addEventListener('load', () => {

  document.querySelectorAll('.ctabs').forEach(section => {

    if (section.dataset.ctabsInit === 'true') return;
    section.dataset.ctabsInit = 'true';

    // Enable/disable infinite loop
    const infiniteLoop = true;

    const tabs   = section.querySelectorAll('.ctabs__tab');
    const panels = section.querySelectorAll('.ctabs__panel');

    // Read CSS custom properties from the section element
    const style         = getComputedStyle(section);
    const colsDesktop   = parseInt(style.getPropertyValue('--ctabs-cols').trim(), 10)        || 3;
    const colsMobile    = parseInt(style.getPropertyValue('--ctabs-cols-mobile').trim(), 10)  || 1;
    const gapDesktop    = parseFloat(style.getPropertyValue('--ctabs-gap').trim())            || 24;
    const gapMobile     = parseFloat(style.getPropertyValue('--ctabs-gap-mobile').trim())     || 12;

    // Keyed by panel element — so each panel keeps its own Swiper instance
    const swiperMap = new Map();

    // ── Tab switching ─────────────────────────────────────────
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const index = parseInt(tab.dataset.tabIndex, 10);

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(p => p.classList.remove('is-active'));

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const activePanel = panels[index];
        if (activePanel) {
          activePanel.classList.add('is-active');
          // Update the swiper for this panel (lazy init if not done yet)
          initOrUpdateSwiper(activePanel);
          // Swiper needs a layout recalc after display:block kicks in
          const sw = swiperMap.get(activePanel);
          if (sw) sw.update();
        }

        // Keep the selected tab in view within the scrollable nav bar —
        // centered on mobile (where the bar scrolls), just "nearest" on
        // desktop where every tab is normally already visible.
        const isMobileNav = window.innerWidth < 768;
        tab.scrollIntoView({
          behavior: 'smooth',
          inline: isMobileNav ? 'center' : 'nearest',
          block: 'nearest',
        });
      });
    });

    // ── Init all panels on load ───────────────────────────────
    panels.forEach(panel => initOrUpdateSwiper(panel));

    // ── Tabs bar: scroll arrows + fade edges ──────────────────
    initTabsNavScroll(section);

    // ── Swiper init ───────────────────────────────────────────
    function initOrUpdateSwiper(panel) {
      if (!panel) return;

      // Already initialised
      if (swiperMap.has(panel)) return;

      const swiperEl = panel.querySelector('.ctabs__carousel.swiper');
      const prevBtn  = panel.querySelector('.ctabs__arrow--prev');
      const nextBtn  = panel.querySelector('.ctabs__arrow--next');

      if (!swiperEl) return;

      const isMobile = () => window.innerWidth < 768;

      const swiper = new Swiper(swiperEl, {
        loop: infiniteLoop,

        slidesPerView:  isMobile() ? colsMobile  : colsDesktop,
        spaceBetween:   isMobile() ? gapMobile   : gapDesktop,
        grabCursor: true,
        touchEventsTarget: 'container',

        // Custom external navigation buttons
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'is-disabled',
        },

        breakpoints: {
          // Mobile
          0: {
            slidesPerView: colsMobile,
            spaceBetween:  gapMobile,
          },
          // Desktop
          768: {
            slidesPerView: colsDesktop,
            spaceBetween:  gapDesktop,
          },
        },

        on: {
          // Keep arrow state accurate after every transition
          slideChange () {
            updateArrows(this, prevBtn, nextBtn);
          },
          init () {
            updateArrows(this, prevBtn, nextBtn);
          },
        },
      });

      swiperMap.set(panel, swiper);
    }

    // ── Arrow state helper ────────────────────────────────────
    function updateArrows(swiper, prevBtn, nextBtn) {
      // Never disable arrows when infinite loop is enabled
      if (infiniteLoop) {
        if (prevBtn) {
          prevBtn.classList.remove('is-disabled');
          prevBtn.disabled = false;
        }

        if (nextBtn) {
          nextBtn.classList.remove('is-disabled');
          nextBtn.disabled = false;
        }

        return;
      }

      if (prevBtn) {
        prevBtn.classList.toggle('is-disabled', swiper.isBeginning);
        prevBtn.disabled = swiper.isBeginning;
      }

      if (nextBtn) {
        nextBtn.classList.toggle('is-disabled', swiper.isEnd);
        nextBtn.disabled = swiper.isEnd;
      }
    }

    // ── Tabs bar scroll arrows + fade edges ───────────────────
    function initTabsNavScroll(section) {
      const nav      = section.querySelector('[data-ctabs-nav]');
      const prevBtn  = section.querySelector('[data-ctabs-nav-prev]');
      const nextBtn  = section.querySelector('[data-ctabs-nav-next]');
      const fadeLeft  = section.querySelector('[data-ctabs-fade-left]');
      const fadeRight = section.querySelector('[data-ctabs-fade-right]');
      if (!nav) return;

      const navTabs = Array.from(tabs);

      function updateNavState() {
        const maxScroll = nav.scrollWidth - nav.clientWidth;
        const atStart = nav.scrollLeft <= 1;
        const atEnd   = nav.scrollLeft >= maxScroll - 1;
        const scrollable = maxScroll > 1;

        // Arrows are always visible; only the fade edges reflect scroll position.
        if (fadeLeft)  fadeLeft.hidden  = !scrollable || atStart;
        if (fadeRight) fadeRight.hidden = !scrollable || atEnd;
      }

      // Arrows cycle the active tab selection (with wraparound), rather
      // than just scrolling the bar — clicking a tab already scrolls it
      // into view, so this reuses that same click handler.
      function goToTab(step) {
        const currentIndex = navTabs.findIndex(t => t.classList.contains('is-active'));
        const base = currentIndex === -1 ? 0 : currentIndex;
        const nextIndex = (base + step + navTabs.length) % navTabs.length;
        navTabs[nextIndex].click();
      }

      if (prevBtn) prevBtn.addEventListener('click', () => goToTab(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => goToTab(1));

      nav.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }

    // ── Recalculate on resize ─────────────────────────────────
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        swiperMap.forEach(swiper => swiper.update());
      }, 150);
    });

  });

});